import { styled } from '@mui/system';
import { theme } from 'oems/theme';



export const Wrapper = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 1rem;

  @media (max-width: ${theme.breakpoints.values.md}px) {
    flex-direction: column;
    gap:0rem;
  }
`;

export const Title = styled('h2')`
  font-weight: 400;
  font-size: 14px;
  line-height: 125%;
  color: ${'#7B809A'};
  margin-bottom: 4px;
`;

export const Subtitle = styled('div')`
  font-weight: 400;
  font-size: 14px;
  line-height: 125%;
  line-width: '500px';
  width: '500px';
  color: ${theme.palette.text.dark};
`;
